import React, { useState, useRef } from 'react';

const DesktopIcon = ({ icon, label, onClick, position, onPositionChange }) => {
  const [isSelected, setIsSelected] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const dragRef = useRef({ startX: 0, startY: 0, offsetX: 0, offsetY: 0 });

  const handleClick = (e) => {
    e.stopPropagation();
    if (!isDragging) {
      setIsSelected(!isSelected);
    }
  };

  const handleDoubleClick = (e) => {
    e.stopPropagation();
    if (onClick) onClick(e);
    console.log(`Opening ${label}`);
  };

  const handleMouseDown = (e) => {
    if (e.button !== 0) return; // Only left mouse button
    
    e.stopPropagation();
    setIsDragging(false);
    
    dragRef.current = {
      startX: e.clientX,
      startY: e.clientY,
      offsetX: e.clientX - position.x,
      offsetY: e.clientY - position.y
    };

    const handleMouseMove = (moveEvent) => {
      const deltaX = Math.abs(moveEvent.clientX - dragRef.current.startX);
      const deltaY = Math.abs(moveEvent.clientY - dragRef.current.startY);
      
      // Only start dragging if moved more than 5 pixels
      if (deltaX > 5 || deltaY > 5) {
        setIsDragging(true);
      }

      if (onPositionChange) {
        onPositionChange({
          x: moveEvent.clientX - dragRef.current.offsetX,
          y: moveEvent.clientY - dragRef.current.offsetY
        });
      }
    };

    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      
      // Reset dragging state after a short delay to prevent click from firing
      setTimeout(() => setIsDragging(false), 100);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  return (
    <div
      className={`flex flex-col items-center p-2 w-16 cursor-pointer select-none absolute
                  ${isSelected ? 'bg-blue-500 bg-opacity-30 border border-blue-400 border-dashed' : ''}
                  hover:bg-blue-200 hover:bg-opacity-20 transition-colors duration-150`}
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`
      }}
      onClick={handleClick}
      onDoubleClick={handleDoubleClick}
      onMouseDown={handleMouseDown}
    >
      <div className="w-8 h-8 mb-1 filter drop-shadow-sm flex items-center justify-center">
        {icon.startsWith('/') ? (
          <img src={icon} alt={label} className="w-full h-full" />
        ) : (
          <span className="text-2xl">{icon}</span>
        )}
      </div>
      <span className="text-white text-xs font-tahoma text-center leading-tight drop-shadow-md">
        {label}
      </span>
    </div>
  );
};

export default DesktopIcon;
